import { LitEntity, html, css } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { StoreMixin } from '../utility/store-mixin';
import './parts/scheduler-user';
import './parts/scheduler-users';

class SchedulerIndex extends StoreMixin(IndexMixin(LitEntity)) {
  static get properties() {
    return {
      userId: { type: String, attribute: false },
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }
    `;
  }

  getViews() {
    return [
      {
        default: true,
        name: 'users',
        render: () => html`<scheduler-users .href="${this.href}"></scheduler-users>`,
      },
      {
        name: 'user',
        render: () => html`<scheduler-user .href="${this.userId}"></scheduler-user>`,
      },
    ];
  }

  _stateChanged({ query }) {
    this.userId = (query || {}).userId;
  }
}

customElements.define('scheduler-index', SchedulerIndex);
